<script setup lang="ts">
    import DialogAktivPatient from "@/tabs/Operation/DialogAktivPatient.vue";
    import { toRefs } from "vue";
    import { PatientDisplay } from "@/tabs/Operation/Oversikt/AnmalanInterfaces";
    import { capitalizeFirstLetter } from "@/tabs/Operation/calendar-utils";

    const props = defineProps<{
        patient: PatientDisplay;
    }>();

    const { patient } = toRefs(props);
</script>

<template>
    <div class="patient-summary">
        <DialogAktivPatient :patient="patient" :showHeader="false" size="medium" variant="alt" />
        <div class="divider"></div>
        <ul>
            <li>
                <span class="label">Ålder</span> <span>{{ patient.age }}</span>
            </li>
            <li>
                <span class="label">Kön</span> <span>{{ capitalizeFirstLetter(patient.gender_display) }}</span>
            </li>
        </ul>
        <div class="divider"></div>
        <ul>
            <li>
                <span class="label">Födelsedatum</span> <span>{{ patient.dateOfBirth }}</span>
            </li>
            <li>
                <span class="label">PatientID</span> <span>{{ patient.patientId }}</span>
            </li>
        </ul>
        <div class="divider"></div>
        <template v-if="patient.telefon">
            <ul>
                <li>
                    <span class="label">Telefon</span> <span>{{ patient.telefon }}</span>
                </li>
            </ul>
            <div class="divider"></div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
    .patient-summary {
        display: flex;
        align-items: center;
        gap: 14px;
        height: 54px;

        .divider {
            border-left: 1px solid #d3d8da;
            height: 38px;
        }

        ul {
            list-style: none;
            padding: 0;
            margin: 0;
            height: 38px;
            display: flex;
            flex-direction: column;
            gap: 6px;
            font-size: 13px;
            line-height: 16px;

            .label {
                font-weight: bold;
                margin-right: 8px;
            }
        }
    }
</style>
